import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    SimpleChange,
    SimpleChanges,
} from '@angular/core';
import {
    UntypedFormBuilder,
    UntypedFormControl,
    UntypedFormGroup,
    Validators,
} from '@angular/forms';
import { ContactTypeModel } from 'app/modules/settings/interfaces/company-account-data';
import { ClientContactsService } from 'app/modules/settings/services/client-contacts.service';
import { ClientInformationSources } from 'app/modules/shared/interfaces/client-data';

@Component({
    selector: 'client-edit-contacts',
    templateUrl: './client-edit-contacts.component.html',
    styleUrls: ['../../client-edit-screen.component.scss', './client-edit-contacts.component.scss'],
})
export class ClientEditContactsComponent implements OnInit {
    initControlsFlag: boolean = false;
    contactTypes: ContactTypeModel[];

    @Input() form: UntypedFormGroup;
    @Input() clientInfoSources: ClientInformationSources;
    @Input() action: string;
    @Output() formGroupEvent = new EventEmitter<UntypedFormGroup>();

    contacts: UntypedFormGroup;
    primaryEmail: UntypedFormControl;
    technicalEmail: UntypedFormControl;

    constructor(
        private clientContactService: ClientContactsService,
        private formBuilder: UntypedFormBuilder
    ) {}

    ngOnInit() {
        this.getPageData();
        this.constructGroup();
    }

    ngOnChanges(changes: SimpleChanges) {
        setTimeout(() => {
            if (changes['form']?.currentValue?.controls?.hasOwnProperty('contacts')) {
                this.initControls();
                this.patchValues();
                this.initControlsFlag = true;
            }
        }, 0);
    }

    constructGroup() {
        let group: UntypedFormGroup = this.formBuilder.group({
            primaryEmail: ['', [Validators.email, Validators.maxLength(120)]],
            technicalEmail: ['', [Validators.email, Validators.maxLength(120)]],
        });

        this.formGroupEvent.emit(group);
    }

    initControls() {
        this.contacts = this.form.get('contacts') as UntypedFormGroup;
        this.primaryEmail = this.contacts.get('primaryEmail') as UntypedFormControl;
        this.technicalEmail = this.contacts.get('technicalEmail') as UntypedFormControl;
    }

    getPageData() {
        this.clientContactService.getContactTypes().subscribe(
            (types) => {
                this.contactTypes = types;
            },
            (error) => {
                throw new Error(error);
            }
        );
    }

    patchValues() {
        this.contacts.patchValue(this.clientInfoSources);
    }
}
